import { Menu } from 'antd';
import React, { useEffect, useState } from 'react';
import { getMenuList } from '../service-link-img/actions';

import './header-menu.scss';

const HeaderMenu = (props) => {
    const [menuItems, setMenuItems] = useState([]);

    useEffect(() => {
        getMenuList(props.context).then((value) => {
            if (value.data) {
                setMenuItems(value.data);
            }
        });
    }, []);

    const getMenuItemHref = (path) => {
        return '/' + props.language + path.replace('/isna-portal-cms', '');
    };

    const goTo = (path: string) => {
        open('/' + props.language + path.replace('/isna-portal-cms', ''), '_self');
    };

    return (
        <Menu
            mode="horizontal"
            className="header-menu"
            items={menuItems
                .filter((x) => !x.dataAsJson.menu)
                .map((x) => ({
                    key: x.id,
                    className: 'menu-link',
                    onClick: () => goTo(x._path),
                    label: x.displayName,
                }))}
        />
    );
};

export default HeaderMenu;
